export default __webpack_public_path__ + "locales/sr-Cyrl-RS/InviteDialog.json?hash=9d08f34f1b5cee549552e12b8d5291bb";